const jQuery = require('jquery/dist/jquery');
window.jQuery = jQuery;
window.$ = jQuery;

// style
require('bootstrap/dist/css/bootstrap.css');
require('./css/responsive.css');
